(function(Manogi, $, undefined) {

    //Private

    //Public



    Manogi.hideShippingAddress = function() {
        $('*[data-form-segment=shipping]').addClass('u-hidden');
    };

    Manogi.showShippingAddress = function() {
        $('*[data-form-segment=shipping]').removeClass('u-hidden');
    };

    Manogi.saveAddressAndContinue = function($form) {
        Manogi.showLoading();
        Manogi.removeAllErrors($form);

        $form.request('checkoutAddress::onSaveCustomerAddress', {
            success: function(response) {
                if (response.failed){
                    if(
                        !response.is_registered
                        && response.errors['email']
                        && response.errors['email'][0]
                           == 'E-Mail-Adresse ist bereits vergeben.'
                    ) {
                        Manogi.openLoginModal('already_registered');
                        Manogi.hideLoading();
                    } else {
                        Manogi.flash(response.message, 'alert');
                        Manogi.hideLoading();
                        $.each(response.errors, function(name,message){
                            $('*[name="'+name+'"]').addClass('u-error');
                            var $message = $('*[name="'+name+'"]').closest('.js-container').find('.js-message');
                            $message.addClass('u-error').text(message);

                        });
                        Manogi.scrollToFirstHighlighted();
                    }

                }
                else {
                    window.location.href = $form.data('success_url');
                }
            },
        });

    };



}( window.Manogi = window.Manogi || {}, jQuery ));
